import moment from "moment"
import React, { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import Settings from "@/common/Settings"
import { useTranslation } from "react-i18next"
import { parsedUser } from "@/common/GetCurrentUser"
import API from "@/common/API"
import MentionInput from "@/components/Common/MentionInput"
import MentionRenderer from "@/components/Common/MentionRenderer"

const VisitListItem = props => {
  const [item, setItem] = useState(props.model)
  const [showComments, setShowComments] = useState(false)
  const { t } = useTranslation("global")
  const user = parsedUser()
  const [comment, setComment] = useState("")
  const [mentionedUserIds, setMentionedUserIds] = useState<string[]>([])
  const [comments, setComments] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const requestComments = async () => {
    if (!item?.id) return
    let query = "visitId=" + item.id
    let requestAPI = await API.getAction("PlaceVisitComment/List", query)
    if (requestAPI?.data?.status === "ok") {
      setComments(requestAPI.data.response || [])
    }
  }

  const submitMessage = async e => {
    try {
      if (comment === "") return

      if (e.key === "Enter") {
        let query = {
          visitId: item.id,
          comment: comment,
          accountId: user.ID,
          mentionedUserIds: mentionedUserIds,
        }
        setIsLoading(true)
        const request = await API.postAction("PlaceVisitComment/AddEdit", query)
        if (request && request.data.status === "ok") {
          setComment("")
          setMentionedUserIds([])
          await requestDetails()
          await requestComments()
          // setShowComments(false)
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }

  const requestDetails = async () => {
    if (!item?.id) return
    let query = "id=" + item.id
    // query += "&OrganizationId=" + user.OrganizationId;
    let requestAPI = await API.getAction("place/VisitDetails", query)
    if (requestAPI?.data?.status === "ok" && requestAPI.data.response) {
      setItem(requestAPI.data.response)
    }
  }

  useEffect(() => {
    if (showComments) {
      requestComments()
    }
  }, [showComments])

  return (
    <Card className="h-100 shadow-sm border-0 instagram-card">
      {/* Header with user info */}
      <div className="position-relative">
        <Card.Header className="px-3 py-2 bg-white border-0">
          <div className="d-flex align-items-center">
            <div className="avatar-circle me-2">
              <i className="fa fa-user text-white"></i>
            </div>
            <div className="flex-grow-1">
              {item?.createdBy && (
                <div className="fw-bold text-dark" style={{ fontSize: "0.9rem" }}>
                  {item.createdBy?.firstName
                    ? `${item.createdBy.firstName} ${item.createdBy.lastName || ""}`
                    : (typeof item.createdBy === "string" ? item.createdBy : "")}
                </div>
              )}
              {item?.created && (
                <small className="text-muted">
                  <i className="fa fa-clock me-1"></i>
                  {moment(item.created).fromNow()}
                </small>
              )}
            </div>

            {/* Options dropdown */}
            <div className="dropdown">
              <button
                className="btn btn-sm btn-link text-muted p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-ellipsis-h"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      let fullAddress = `${item.latitude},${item.longitude}`
                      window.open(
                        `https://www.google.com/maps/search/?api=1&query=${fullAddress}`,
                        "MapWindow",
                        "width=1280,height=840"
                      )
                    }}
                  >
                    <i className="fa fa-map-pin me-2"></i>
                    Ver en mapa
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </Card.Header>

        {/* Main image */}
        <div className="instagram-image-container">
          <img
            loading="lazy"
            className="instagram-image"
            src={`${Settings.BasePathForAPI}file/getThumbnail?filename=${item.image}`}
            alt="Visita"
            onError={(e) => {
              e.currentTarget.src = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0iIzk5OTk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPk5vIGltYWdlbjwvdGV4dD48L3N2Zz4="
            }}
          />
        </div>

        {/* Action buttons overlay */}
        <div className="instagram-overlay">
          <button
            className="btn btn-light btn-sm rounded-circle me-2"
            title={t("Comment")}
            onClick={() => {
              if (!showComments) {
                document.getElementById(`commentBox-${item.id}`)?.focus()
              }
              setShowComments(!showComments)
            }}
          >
            <i className="fa fa-comment"></i>
          </button>

          <button
            className="btn btn-light btn-sm rounded-circle"
            title={t("See map")}
            onClick={() => {
              let fullAddress = `${item.latitude},${item.longitude}`
              window.open(
                `https://www.google.com/maps/search/?api=1&query=${fullAddress}`,
                "MapWindow",
                "width=1280,height=840"
              )
            }}
          >
            <i className="fa fa-map-pin"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <Card.Body className="px-3 py-2">
        {/* Engagement stats */}
        <div className="d-flex align-items-center mb-2">
          <button
            className="btn btn-link p-0 text-decoration-none text-dark"
            onClick={() => setShowComments(!showComments)}
          >
            <i className="fa fa-comment me-1"></i>
            <span className="fw-bold">{item.commentsCount || 0}</span>
            <span className="text-muted ms-1">comentarios</span>
          </button>
        </div>

        {/* Caption */}
        {item?.note && (
          <div className="instagram-caption" style={{ whiteSpace: "pre-line" }}>
            {item.createdBy?.firstName && (
              <span className="fw-bold me-2">{item.createdBy.firstName}</span>
            )}
            <span>{item.note}</span>
          </div>
        )}

        {/* Comments section */}
        {showComments && (
          <div className="instagram-comments mt-3">
            {comments && comments.length > 0 && (
              <div className="comments-list mb-3">
                {comments.slice(0, 3).map((comment: any, index: number) => (
                  <div key={index} className="comment-item mb-2">
                    <span className="fw-bold me-2">
                      {comment?.account?.firstName || "Usuario"} {comment?.account?.lastName || ""}
                    </span>
                    <span className="comment-text">
                      <MentionRenderer text={comment.comment} />
                    </span>
                    <div>
                      <small className="text-muted">
                        {moment(comment.created).fromNow()}
                      </small>
                    </div>
                  </div>
                ))}

                {comments.length > 3 && (
                  <button
                    className="btn btn-link p-0 text-muted small"
                    onClick={() => {/* TODO: Show all comments */ }}
                  >
                    Ver los {comments.length - 3} comentarios restantes
                  </button>
                )}
              </div>
            )}

            {/* Add comment input */}
            <div className="add-comment">
              <MentionInput
                id={`commentBox-${item.id}`}
                disabled={isLoading}
                className="form-control-sm border-0 bg-light rounded-pill px-3"
                placeholder="Añade un comentario (usa @ para mencionar)..."
                value={comment}
                onKeyDown={submitMessage}
                onChange={(val, ids) => {
                  setComment(val)
                  setMentionedUserIds(ids)
                }}
                showQuickAtButton={true}
              />
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default VisitListItem
